<template>

    <div class="user-home-page dashboard-page">

        <header4IQ :fromapp="'ug'"></header4IQ>

        <Snackbar
            v-if="showSnackbar"
            :snackbarColor="snackbarColor"
            :snackbarMessage="snackbarMessage"
            @close="closeSnackbar()"
        >
        </Snackbar>

        <AdvancedSearch :enablePopup="advancedSearchPopUp" @togglepopup="(val) => advancedSearchPopUp = val"/>
        <main class="main-container" v-if="!advancedSearchPopUp">

            <section>
                <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                        <v-flex xl12 class="apps_and_users_tool_bar">
                            <v-toolbar style="color:indigo;" dense flat color="#EFEFEF">

                                <!-- <v-toolbar-title>
                                    Users ( {{ getUsersData.length }} )
                                </v-toolbar-title> -->

                                <v-btn-toggle v-model="page" borderless mandatory class="apps_and_users_buttons">
                                    <v-btn value="tenants" v-show="isSuperAdmin || isSuperUser">
                                        <span class="hidden-sm-and-down">Tenants</span>
                                    </v-btn>
                        
                                    <v-btn value="apps" v-show="isTenantAdmin || isSuperAdmin || isSuperUser">
                                        <span class="hidden-sm-and-down">{{tenantInfo.app_label || 'Apps'}}</span>
                                    </v-btn>
                        
                                    <v-btn value="users">
                                        <span class="hidden-sm-and-down">Users ( {{ getUsersData.filter(item => enableAdvancedSearch ? tenantSeperatedDetails[tenantInfo['schema_name']].user_id.includes(item.pk) : true).length }} )</span>
                                    </v-btn>
                                </v-btn-toggle>

                                <v-spacer></v-spacer>
                                <span style="display:flex;">
                                    <v-icon title="Search" id="enableUsersSearch" @click="enableSearch = true">search</v-icon>
                                    <v-text-field v-if="enableSearch" label="Search" append-icon="clear" id="closeUsersSearch" @click:append="enableSearch = false; searchText = ''" autofocus v-model="searchText">
                                    </v-text-field>
                                </span>
                                <span v-show="isSuperAdmin" style="display:flex;">
                                    <v-icon title="Advanced Search" id="enableSearch" :color="enableAdvancedSearch ? '#e34d25 !important' : ''" @click="(advancedSearchPopUp = !advancedSearchPopUp)">zoom_in</v-icon>&nbsp; &nbsp; 
                                </span>
                                <!-- <span v-show="isTenantAdmin || isSuperAdmin || isSuperUser" title="Go to Apps Page" id="gotoAppsPage" @click="goToAppsPage()">
                                    <v-icon>brightness_auto</v-icon>
                                </span> -->
                                <span v-show="isSuperAdmin || isSuperUser" title="Notes"><i class="material-icons" id="showNotes" @click="showNotesPopup()">note</i></span>
                                <span v-show="isSuperAdmin || isTenantAdmin" title="Create User"> <v-icon id="createUser" @click="addNewUserPopup()">add</v-icon> </span>
                            </v-toolbar>
                        </v-flex>
                    </v-layout>
                </v-container>
            </section>
            <!-- Users card creation -->
            <section class="companies">

                <v-container fluid grid-list-lg>
                     <v-layout row wrap>
                        <v-flex lg3 v-for="(user, index) in getUsersData.filter(item => enableAdvancedSearch? tenantSeperatedDetails[tenantInfo['schema_name']].user_id.includes(item.pk) : true)" :key="user.title">
                            <v-card id="usersCard">
                                <v-layout class="tenant-card">
                                    <v-flex xs5 class="company-logo" overflow-hidden>
                                        <span><img src="../../../common/assets/images/default-user-icon.png" class="logo-img"/></span>
                                    </v-flex>
                                    <v-flex xs7 class="company-info">
                                        <v-layout row wrap>
                                            <v-flex xs12>
                                                <h6 class="company-name" :title="user.email">{{user.email}}</h6>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout class="users_card-bottom">
                                            <v-flex xs5>
                                                <v-icon>brightness_auto</v-icon>
                                                <span>{{Object.values(user.apps_information).length}} Apps</span>
                                            </v-flex>
                                            <v-flex xs7>
                                                <v-icon>local_library</v-icon>
                                                <span>{{Object.values(user.docs_information).length}} Documents</span>
                                            </v-flex>
                                        </v-layout>
                                        <v-layout  row wrap>
                                            <v-flex xs12 class="refresh-date">
                                                <v-icon>schedule</v-icon>&nbsp;
                                                <span v-text="formateDate(user.date_joined)"></span>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                                <v-divider class="purple darken-3"></v-divider>
                                <v-card-actions>
                                    <h3 class="company-name" :title="user.username" v-text="user.username"></h3>&nbsp;
                                    <v-icon v-if="user.tenant_admin" title="Tenant Admin">group</v-icon>
                                    <v-icon class="ml-2" v-if="user.user_type != 'non_sso'" title="Single Sign-On enabled">loop</v-icon>
                                    <v-spacer></v-spacer>
                                    <!-- Actions menu -->
                                    <v-menu transition="scale-transition" :close-on-content-click="false" offset-x right>
                                        <template v-slot:activator="{ on }">
                                        <v-btn v-if="!isSuperUser" icon slot="activator" v-on="on" color="grey" @click="editableUserIndex = index;">
                                            <v-icon>more_vert</v-icon>
                                        </v-btn>
                                        </template>
                                        <v-list>
                                            <v-list-item @click="editUser(user,index)">
                                                <v-list-item-title>
                                                    Edit
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="!(user.email == loginEmail && user.user_role && loginSchemaName == user.current_schema['schema_name'])" @click="addUserasTenantAdmin(user,index)">
                                                <v-list-item-title v-if="!user.tenant_admin">
                                                    Enable Tenant Admin
                                                </v-list-item-title>
                                                <v-list-item-title v-else>
                                                    Disable Tenant Admin
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <v-list-item :class="user.email ? '':'disabled'" @click="resendEmail(user, 'uigCredentials')" v-if="user.user_type == 'sso' & !makeUserHybrid">
                                                <v-list-item-title>
                                                    Enable UIG credentials
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item  @click="resendEmail(user)" v-if="!['sso'].includes(user.user_type)">
                                                <v-list-item-title>
                                                    Resend Welcome Email
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item @click="isChangePassword = true;userInComponent=user" v-if="!['sso'].includes(user.user_type)">
                                                <v-list-item-title>
                                                    Change Password
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-list-item v-if="tenantInfo && tenantInfo['2fa_enabled'] || isTenantAdmin" :class="user['2fa_enabled'] ? 'enabled' :'disabled'" @click="reset2FAConfirmation = true;userInComponent=user">
                                                <v-list-item-title>
                                                    Reset 2FA
                                                </v-list-item-title>
                                            </v-list-item>
                                            <v-divider></v-divider>
                                            <v-list-item :class="(loggedInUserInformation['username'] == user['username'] && loggedInTenantInformation['schema_name'] == user['current_schema']['schema_name']) || (['sso'].includes(user.user_type)) ? 'disabled' : ''" @click="deleteConfirmation = true;userInComponent=user">
                                                <v-list-item-title>
                                                    Delete
                                                </v-list-item-title>
                                            </v-list-item>
                                        </v-list>
                                    </v-menu>
                                    <!-- END - Actions menu -->
                                </v-card-actions>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </section>
            <!-- END - Users card creation -->
            <!-- user card creation popup -->
            <section>
                <v-dialog width="60rem" persistent class="show-info-popup" v-model="enableNewUser">
                    <v-card class="popup-card">
                        <div class="user_creation_popup_div">
                            <div>
                                <v-layout row wrap>
                                    <v-flex xs1 class="pa-2 ma-2">
                                        <img src="../../../common/assets/images/default-user-icon.png" id="profile-img-tag"
                                            class="logo-img"/>
                                    </v-flex>
                                    <v-flex xs10 class="pa-1 ma-2 mt-4 pt-3">
                                        <h3 v-text="editableUserIndex == -1 ? 'Create user ' : 'Update user'"></h3>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>

                                        <v-flex xs3 class="pt-3 ma-2 pl-2">
                                            Email *
                                        </v-flex>
                                        <v-flex xs8>
                                            <v-form
                                                ref="form"
                                                v-model="valid"
                                                lazy-validation
                                            >
                                                <v-text-field
                                                    id="userEmail"
                                                    v-model="newuser.email"
                                                    :rules='emailRules'
                                                    label="Email"
                                                    required
                                                ></v-text-field>
                                            </v-form>
                                        </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        User Name *
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            id="userName"
                                            v-model="newuser.username"
                                            label="User Name"
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        First Name 
                                    </v-flex>
                                    <v-flex xs8>
                                        <v-text-field
                                            id="userFirstName"
                                            v-model="newuser.firstname"
                                            label="First Name"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        <span>
                                            Apps
                                        </span>
                                    </v-flex>
                                    <v-flex xs8 overflow-hidden>
                                        <v-select
                                            id="appsListDropdown"
                                            :items="updatedUiUsersAppList"
                                            v-model="updatedUiSelectedAppsList"
                                            label="Apps"
                                            multiple
                                            chips
                                        >
                                        <template slot="selection"  slot-scope="{ item , index }">
                                            <v-chip v-if="index === 0">
                                                <span>{{item}}</span>
                                            </v-chip>
                                            <span v-if="index === 0" class="grey--text">
                                                (+{{ updatedUiSelectedAppsList.length - 1 }} apps)
                                            </span>
                                        </template>
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap>
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        <span>
                                            Documents
                                        </span>
                                    </v-flex>
                                    <v-flex xs8 fluid>
                                        <v-select
                                            id="docsListDropdown"
                                            :items="updatedUiTotalDocsListValues"
                                            v-model="updatedUiSelectedDocsList"
                                            label="Documents"
                                            multiple
                                            chips
                                        ></v-select>
                                    </v-flex>
                                </v-layout>
                                <fieldset v-if="tenantInfo.schema_name == 'public'" class="mt-2 mb-5 pa-3 pr-0">
                                    <legend>Access To Tenants</legend>
                                    <v-layout row wrap>
                                        <v-flex xs3 class="pt-5 ma-2 pl-2">
                                            Tenant Filters/Groups
                                        </v-flex>
                                        <v-flex xs8 fluid>
                                            <v-autocomplete
                                                id="selectTenantServerDropdown"
                                                v-model="newuser.servers_list"
                                                :items="tenantGroupList"
                                                item-value="field"
                                                item-text="display_name"
                                                label="Select Server Type"
                                                @input="searchInput=null"
                                                :search-input.sync="searchInput"
                                                @focus="onChange('tenantGrouping')"
                                                v-on:change="selectAllTenants();"
                                                multiple
                                                chips
                                            >   
                                            </v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs3 class="pt-4 ma-2 pl-2">
                                            Exclude Tenants
                                        </v-flex> 
                                        <v-flex xs8 fluid>
                                            <v-autocomplete
                                                id="excludeSpecificTenants"
                                                v-model="newuser.exclude_tenants"
                                                :items="excludeTenantsList" 
                                                label="Exclude Tenants"
                                                item-value="id"
                                                item-text="tenant_name"
                                                @input="searchInput=null"
                                                :search-input.sync="searchInput"
                                                @focus="onChange('excludeTenant')"
                                                multiple 
                                                chips
                                                >
                                                <template v-slot:selection="{ item, index }">
                                                    <v-chip v-if="index <= 3 ">
                                                        <span>{{ item.tenant_name }}</span>
                                                    </v-chip>
                                                        <span
                                                            v-if="index === 4"
                                                            class="grey--text text-caption"
                                                        >
                                                        (+{{ newuser.exclude_tenants.length - 4 }} more)
                                                        </span>
                                                </template>
                                            </v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                    <v-layout row wrap>
                                        <v-flex xs3 class="pt-3 ma-2 pl-2">
                                            Include Tenants
                                        </v-flex>
                                        <v-flex xs8 fluid>
                                            <v-autocomplete
                                                id="includelists"
                                                v-model="newuser.include_tenants"
                                                :items="includeTenants"
                                                label="TenantLists"
                                                item-value="id"
                                                item-text="tenant_name"
                                                @input="searchInput=null"
                                                :search-input.sync="searchInput"
                                                @focus="onChange('includeTenant')"
                                                multiple
                                                chips
                                            >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index <= 3">
                                                    <span>{{ item.tenant_name }}</span>
                                                </v-chip>
                                                    <span
                                                        v-if="index === 4"
                                                        class="grey--text text-caption"
                                                    >
                                                    (+{{ newuser.include_tenants.length - 4 }} others)
                                                    </span>
                                            </template>
                                            </v-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </fieldset>
                                <v-layout row wrap v-if="tenantInfo.schema_name == 'public'">
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        User Roles
                                    </v-flex>
                                    <v-flex xs8 fluid>
                                        <v-radio-group v-model="newuser.selectedUserRole" row>
                                            <v-radio v-for="(roletype, index) in userRolesList" :key="index"
                                                :label="roletype.label"
                                                :value="roletype.value"
                                                color="indigo">
                                            </v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout row wrap v-if="tenantInfo.schema_name == 'public' && newuser.selectedUserRole != null">
                                    <v-flex xs3 class="pt-3 ma-2 pl-2">
                                        App type roles
                                    </v-flex> 
                                    <v-flex xs8 fluid>
                                        <v-select 
                                            :items="appTypeRolesList"
                                            v-model="newuser.selected_app_type_roles"
                                            label="App type roles"
                                            multiple
                                            chips
                                            >
                                            <template v-slot:selection="{ item, index }">
                                                <v-chip v-if="index <= 3 ">
                                                    <span>{{ item }}</span>
                                                </v-chip>
                                                    <span
                                                        v-if="index === 4"
                                                        class="grey--text text-caption"
                                                    >
                                                    (+{{ newuser.selected_app_type_roles.length - 4 }} more)
                                                    </span>
                                            </template>
                                        </v-select>
                                    </v-flex>
                                </v-layout>
                            </div>
                            <v-layout row wrap>
                                <v-flex xs12 class="pa-2 ma-3 pt-2 save_in_app_creation">
                                    <v-spacer></v-spacer>
                                    <v-btn depressed class="ma-2" color="grey lighten-3" id="cancelEdit" @click="cancelEdit">
                                        cancel
                                    </v-btn>
                                    <div :class="disableActionBtn? 'disabled' : ''">
                                    <v-btn depressed class="ma-2" color="grey lighten-3" id="userActionBtn"
                                        @click="addNewUser(newuser.email, null,'save')"
                                        :class="validateUserEmail && validateUserEmail != 'Not a valid E-mail'  && newuser.username ? 'enable' : 'disabled'"
                                        v-text="editableUserIndex == -1 ? 'create' :'update'"
                                        tabindex = -1>
                                    </v-btn>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </div>
                    </v-card>
                </v-dialog>
            </section>
            <!-- END - user card creation popup -->
            <changePasswordPopupVue
                :fromheader='false'
                :userID="userInComponent.pk"
                :schemaName="tenantInfo.schema_name"
                v-if="isChangePassword"
                :dialogStatus="isChangePassword"
                @close="closeChangePasswordPopup();">
            </changePasswordPopupVue>
            <confirmationPopupVue
                v-if="deleteConfirmation || reset2FAConfirmation"
                :confirmationTitle="deleteConfirmation ? 'Delete User' : 'Reset 2FA'"
                :name ="userInComponent.username"
                :confirmationText ="deleteConfirmation ? 'delete user' : 'reset 2FA for user'"
                @action="deleteConfirmation ? deleteUser(userInComponent) : reset2FA(userInComponent)"
                @close="closeConfirmationPopUP();">
            </confirmationPopupVue>
            <NotesComponent
                v-if="notesPopup"
                :notesInfo="notesInfo"
                @close="closeNotes();">
            </NotesComponent>
        </main>

    </div>

</template>

<script>
import {filterBy, reverse, findBy} from '../../../common/assets/utils/filters.js';
import { mixin as clickaway } from 'vue-clickaway';
import {formateDate} from '../../../common/assets/utils/formats.js';
import {hideLoadIcon,showLoadIcon} from '../../../common/assets/utils/load.js';
import header4IQ from '../../../common/components/header.vue';
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';
import changePasswordPopupVue from '../../../common/components/changePasswordPopup.vue';
import confirmationPopupVue from '../../../common/components/confirmationPopup';
import NotesComponent from "../subcomponents/notes";
import Snackbar from "../../../common/components/snackbar"
import AdvancedSearch from "../subcomponents/AdvancedSearch.vue";

export default {
    name: 'users-Component',
    data () {
        return {
            page: 'users',
            apps: [],
            enableSearch: false,
            searchText: '',
            enableNewUser: false,
            newuser: {},
            errorText: false,
            editableUserIndex: -1,
            isChangePassword: false,
            userEmail: '',
            selectedDocs: {},
            store_complete_apps : [],
            listToSend : '',
            sendListCount : 0,
            isTenantAdmin:false,
            isSuperAdmin: false,
            isSuperUser: false,
            loginEmail:'',
            loginSchemaName: '',
            showSnackbar: false,
            snackbarMessage : null,
            snackbarColor : null,
            reset2FAConfirmation: false,
            deleteConfirmation: false,
            // new data
            valid:false,
            updatedUiUsersAppList:[],
            updatedUiSelectedAppsList:[],
            updatedUiTotalDocsListValues:[],
            updatedUiSelectedDocsList:[],
            validateUserEmail : null,
            emailRules: [
                v => !!v || 'Email is required.',
                v => /\S+@\S+\.+\S{2}/.test(v) ? this.validateUserEmail = true : this.validateUserEmail = null  || "Not a valid E-mail",
            ],
            updatedUiTotalDocsListKeys: [],
            userInComponent : {},
            appTokensList:[],
            collectionOfApptokensAndPk : [],
            notesPopup: false,
            notesInfo: {},
            disableActionBtn:false,
            hide: null,
            userRolesList: [
                {label: 'Super Admin', value: 'superAdmin'},
                {label: 'User', value: 'User'},
            ],
            selectedUserRole: null,
            appTypeRolesList: [],
            makeUserHybrid: false,
            excludeTenantsList: [],
            includeTenants: [],
            tenantGroupList: [],
            allTenants: false,
            searchInput:null,
            advancedSearchPopUp:false,
            searchInput:null,
        }
    },
    components: {
        AdvancedSearch,
        header4IQ,
        changePasswordPopupVue,
        confirmationPopupVue,
        NotesComponent,
        Snackbar,
    },
    created(){
        this.getTenantslist();
        this.getTenantServers();
        if(this.loggedInUserInformation){
            this.initializeUserPageData();
        }else{
            this.initializeData({});
        }
    },
    computed: {
        ...mapState({
            loggedInUserInformation: state => state.loginDetails.loggedInUserInformation,
            tenantInfo: state => state.loginDetails.loggedInUserInformation ? state.loginDetails.loggedInUserInformation['switched_tenant'] : {},
            loggedInTenantInformation: state => state.loginDetails.loggedInUserInformation ? state.loginDetails.loggedInUserInformation['tenant_information'] : {},
            users: state => state.usersDetails.allUsers,
            appsData: state => state.appsDetails.allApps,
            enableAdvancedSearch: state => state.advancedSearchDetails.enableAdvancedSearch,
            tenantSeperatedDetails: state => state.advancedSearchDetails.tenantSeperatedDetails
        }),
        getUsersData(){
            return this.filterBy(this.users, this.searchText , ['username'], false, {users: 'All'});
        },
        checkSuperUser() {
            return this.tenantInfo.schema_name == 'public' ? true : false;
        }
    },
    watch: {
        loggedInUserInformation(){
            if(this.loggedInUserInformation){
                this.initializeUserPageData();
            }
        },
        appsData(){
            this.formatAppsData();
        },
        page(){
            if(this.page && this.page != 'users'){
                this.$router.push(`/${this.page}`);
            }
        }
    },
    methods: {
        ...mapActions({
            initializeData: 'loginDetails/initializeData',
            getUsers: 'usersDetails/getAllUsersData',
            getApps: 'appsDetails/getAllAppsData',
            syncTenantsData: 'tenantDetails/syncTenantsData', 
        }),
        initializeUserPageData(){
            var self = this;

            if(self.appsData && self.appsData.length == 0){
                self.getApps();
            }else{
                self.formatAppsData();
            }

            if(self.users && self.users.length == 0){
                self.getUsers();
            }

            self.isSuperAdmin = self.loggedInUserInformation['is_superadmin'];
            self.isSuperUser = self.loggedInUserInformation['is_superuser'];
            self.isTenantAdmin = self.loggedInUserInformation['is_tenantadmin'];
            self.loginEmail = self.loggedInUserInformation.email;
            
            self.loginSchemaName = self.loggedInTenantInformation.schema_name;
        },
        formatAppsData(){
            let self = this;
            let appsData = self.appsData;
            let user_token = '';
            let user_name = '';
            let newData = [];
            self.updatedUiUsersAppList = [];
            self.collectionOf_apps_and_pk = [];
            for(let app in appsData){
                appsData[app]['fields']['service']['app_display_name'] = appsData[app].fields.name;
                appsData[app]['fields']['service']['disabled'] = appsData[app].fields.disabled;
                newData.push(appsData[app]['fields']['service']);
                user_token = appsData[app]['fields']['service_details']['usertoken'];
                user_name = appsData[app]['fields']['service_details']['username'];
                self.appTokensList[app] = appsData[app]['fields']['service_details']['app_token'];
                self.collectionOf_apps_and_pk[app] = {
                    [appsData[app].fields.name+" ( "+appsData[app]['fields']['service_details']['app_token'].slice(0,4)+"... )"] : appsData[app].pk
                }
                self.collectionOfApptokensAndPk[app] = {
                    [appsData[app].pk] : " ( "+(appsData[app]['fields']['service_details']['app_token']).slice(0,4)+"... )"
                }
            }
            self.apps = newData;
            for(let item in self.apps){
                if(self.apps[item]['disabled'] == false){
                    self.updatedUiUsersAppList.push(self.apps[item]['app_display_name']+" ( "+self.appTokensList[item].slice(0,4)+"... )");
                }
            }
        },
        getTenantslist(){
            var self = this;
            // Vue.http.get('/get_tenantslist_and_apptype_roles')
            Vue.http.get('/get_tenantslist')  //remove when backend code is ready. 
            .then((res) =>{
                let response = res.data ? res.data.data : {};
                let userCardInfo = {
                    'list_of_tenants': response ? response['list_of_tenants'] : [],
                    'app_type_roles': response ? response['app_type_roles'] : []
                }
                // self.listOfTenants = res.data ? res.data.data : [];
                // self.listOfTenants = userCardInfo['list_of_tenants'];
                self.appTypeRolesList = userCardInfo['app_type_roles'];
            }, (error) => {
                console.log(error);
            })
        },
        // Functions to display snackbar for success/error messages
        displaySnackbar(color,message){
            var self = this;
            self.showSnackbar = false;
            setTimeout(function(){
                self.showSnackbar = true;
            },100)
            self.snackbarColor = color;
            self.snackbarMessage = message;
        },
        closeSnackbar(){
            var self = this;
            self.showSnackbar = false;
            self.snackbarColor = null;
            self.snackbarMessage = null;
        },
        reset2FA(user){
            var self = this, formData = new FormData();
            var csrfTOken = this.getCSFRToken('csrftoken');
            formData.append('csrfmiddlewaretoken', csrfTOken);
            formData.append('user', user['pk']);
            formData.append('schema_name', self.tenantInfo.schema_name);
            showLoadIcon();
            this.$loading(true);
            Vue.http.post("/settings/mfa/disable/", formData)
            .then((res) => {
                try{
                    user['showConfirmation'] = false;
                    user['2fa_enabled'] = false;
                    self.reset2FAConfirmation = false;
                    self.snackbarMessage = "Successfully 2FA was reset for user "+ user.username;
                }
                catch(err){
                    console.log("error is:",err);
                }
                finally{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                }
                self.displaySnackbar('success-banner',self.snackbarMessage);
            }, (error) => {
                self.hide = hideLoadIcon();
                if(!self.hide){
                    this.$loading(false);
                }
                self.displaySnackbar('error-banner',error.data.message);
            });
        },
        deleteUser(user){
            var self = this, formData = new FormData();
            formData.append('json', JSON.stringify({'pk' : user.pk}));
            if(user.email){
                showLoadIcon();
                this.$loading(true);
                Vue.http.post('/delete_user/',formData)
                .then((data) => {
                    try{
                        self.newuser = {
                            'email' : '',
                            'password' : '',
                            'cpassword': '',
                            'schema_name' : self.tenantInfo.schema_name,
                            'is_staff': true,
                            'is_superuser' : true,
                            'username' : '',
                            'lastname' : '',
                            'firstname':'',
                            'selectedApps': [],
                        };
                        self.deleteConfirmation = false;
                        var deletedUserIndex = self.users.findIndex(x => x.username === (user.username));
                        self.users.splice(deletedUserIndex,1);
                        self.syncTenantsData({from: 'usersPage', tenantDomain: self.tenantInfo['domain_name'], userDeleted: true})
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                    self.displaySnackbar('success-banner',"Successfully deleted user");
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                })
            }else{
                // console.log('error')
            }
        },
        closeConfirmationPopUP(){
            var self =  this;
            self.deleteConfirmation = false;
            self.reset2FAConfirmation = false;
            self.userInComponent = {};
        },
        closeChangePasswordPopup(){
            var self = this;
            self.isChangePassword = false;
            self.userInComponent = {};
        },
        getTenantServers() {
            var self = this;
            Vue.http.get('/get_tenant_filters/')
            .then((res) =>{
                self.tenantGroupList = res.data || [];
            }, (error) => {
                console.log(error);
            })
        },
        changeDocsAccess(){
            var self = this;
            showLoadIcon();
            self.$loading(true);
            Vue.http.get('/userdocs/').then((res)=>{
                    try{
                        self.updatedUiTotalDocsListKeys = Object.keys(res.data);
                        self.updatedUiTotalDocsListValues = Object.values(res.data);
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                },(error)=>{
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
            });
        },
        // goToAppsPage(){
        //     this.$router.push('/apps');
        // },
        showNotesPopup(){
            var self = this;
            self.notesPopup = true;
            self.notesInfo = {
                'tenant': self.tenantInfo.domain_name,
                'schemaName': self.tenantInfo.schema_name,
                'notes' : "",
                'username' : self.loggedInUserInformation.username,
                'timeStamp' : new Date()
            }
        },
        closeNotes(){
            var self = this;
            self.notesPopup=false;
            self.notesInfo={};
        },
        addUserasTenantAdmin(user){
            var self = this, makeUserAsTenantAdmin = null;
            var action = '';
            user.tenant_admin ? (makeUserAsTenantAdmin = 'User',action = 'update') : (makeUserAsTenantAdmin = 'tenantAdmin',action = 'save');
            var formData = new FormData();
            formData.append('json', JSON.stringify({
            'role': makeUserAsTenantAdmin,
            'action':action,
            'user_id': user.pk
            }));
            showLoadIcon();
            this.$loading(true);
            Vue.http.post('/role/assign/',formData)
                .then((data) => {
                    try{
                        self.getUsers();
                        self.snackbarMessage = (makeUserAsTenantAdmin == 'tenantAdmin' ? "Enabled Tenant Admin role to ": "Disabled Tenant Admin role to ")+user.username;
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                    self.displaySnackbar('success-banner',self.snackbarMessage);
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                })
        },
        validateEmail(email){
            var remailtext = /^\w+([\.-]?\w+)*$/;
            var remaildomain = /^\w+([\.-]?\w+)*(\.\w{2,27})+$/;
            var emailinfo = email.split('@');
            if(emailinfo.length == 2 && emailinfo[0].match(remailtext) && emailinfo[1].match(remaildomain)){
                return true;
            }else{
                return false;
            }
        },
        addNewUserPopup(){
            var self = this;
            var today = new Date();
            self.newuser = {
                'email' : '',
                'password' : '',
                'cpassword': '',
                'schema_name' : self.tenantInfo.schema_name,
                'is_staff': true,
                'is_superuser' : true,
                'username' : '',
                'lastname' : '',
                'firstname':'',
                'selectedApps': [],
                'selectedUserRole': 'superAdmin',
                'servers_list': [],
                'include_tenants': [],
                'exclude_tenants': []
            };
            self.selectAllTenants();
            self.editableUserIndex = -1;
            // self.$refs.form.reset();
            self.isChangePassword = false;
            self.enableNewUser = !self.enableNewUser;
            self.updatedUiSelectedAppsList = [];
            self.updatedUiSelectedDocsList = [];
            self.changeDocsAccess();
            setTimeout(function(){
                window.scrollTo(0, document.body.scrollHeight);
            },1);
        },
        addNewUser(useremail,userpwd,action){
            useremail = useremail.toLowerCase();
            var self = this, formData = new FormData() ;
            var listofPk = [];
            if(action == 'save'){
                self.newuser.email = useremail;
                self.newuser.password = userpwd;
            }
            for(var i = 0;i < self.collectionOf_apps_and_pk.length;i++){
                for(var j = 0 ;j<self.updatedUiSelectedAppsList.length;j++){
                    if(self.collectionOf_apps_and_pk[i][self.updatedUiSelectedAppsList[j]] != undefined){
                        listofPk.push(self.collectionOf_apps_and_pk[i][self.updatedUiSelectedAppsList[j]]);
                    }
                }
            }
            if(action == 'update'){
                if(self.sendListCount != 0 )
                {
                    for(var item in self.collectionOf_apps_and_pk){
                        if(self.collectionOf_apps_and_pk.hasOwnProperty(item)){
                            for(var item2 in self.updatedUiSelectedAppsList){
                                if(self.collectionOf_apps_and_pk[item][self.updatedUiSelectedAppsList[item2]] != undefined && listofPk.length < self.updatedUiSelectedAppsList.length)
                                    listofPk.push(self.collectionOf_apps_and_pk[item][self.updatedUiSelectedAppsList[item2]]);
                            }
                        }
                    }
                }
            }
            var updatedUiSelectedDocsList_keys = []
            for(var value1 in self.updatedUiTotalDocsListValues){
                if(self.updatedUiTotalDocsListValues.hasOwnProperty(value1)){
                    for(var value2 in self.updatedUiSelectedDocsList){
                        if(self.updatedUiTotalDocsListValues[value1] == self.updatedUiSelectedDocsList[value2]){
                            updatedUiSelectedDocsList_keys.push(parseInt(self.updatedUiTotalDocsListKeys[value1],10))
                        }
                    }
                }
            }
            var userData = {'email' : self.newuser.email,
                            'username' : self.newuser.username,
                            'firstname' : self.newuser.firstname || '',
                            'lastname': '',
                            'is_superuser' : self.newuser.schema_name == 'public' ? true : false,
                            'selectedApps' : listofPk, //get pk values based on selected apps
                            'selectedDocs' : updatedUiSelectedDocsList_keys,
                            'action':'save',
                            'tenant_include_list': self.newuser.include_tenants || [],
                            'tenant_exclude_list':self.newuser.exclude_tenants || [],
                            'tenant_filters': self.allTenants ? ["all_tenants"] : self.newuser.servers_list || [],
                            'selected_app_type_roles': self.newuser.selected_app_type_roles || [],
                            'selected_user_role': self.newuser.selectedUserRole || null
                            };
            if(self.newuser.email){
                if(self.editableUserIndex >= 0){
                    userData['pk'] = self.newuser.pk;
                    userData['action'] = 'update';
                    if(self.isChangePassword){
                        userData = {'pk': self.newuser.pk,
                                    'password': self.newuser.password,
                                    'action': 'update_password'};
                    }
                }
                formData.append('json', JSON.stringify(userData));
                self.disableActionBtn = true;
                setTimeout(function(){
                    self.disableActionBtn = false;
                },2000);
                showLoadIcon();
                this.$loading(true);
                Vue.http.post('/create_user/',formData)
                .then((data) => {
                    try{
                        self.store_complete_apps = [];
                        for(var app in self.apps){
                            if(self.apps.hasOwnProperty(app)){
                                self.store_complete_apps.push(self.apps[app].app_display_name);
                            }
                        }
                        self.enableNewUser = false;
                        self.newcmpny = {};
                        self.errorText = false;
                        self.editableUserIndex = -1;
                        self.isChangePassword = false;
                        self.sendListCount = 0;
                        self.getUsers();
                        self.snackbarMessage = (userData.action == 'save' ? 'Successfully Created User ' : 'Successfully Updated User ') + userData.username;
                        self.syncTenantsData({from: 'usersPage', tenantDomain: self.tenantInfo['domain_name'], userDeleted: false});
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                    self.displaySnackbar('success-banner',self.snackbarMessage);
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                })
            }else{
                self.errorText = true;
            }
        },
        cancelEdit(){
            var self = this;
            self.editableUserIndex = -1;
            self.isChangePassword = false;
            self.enableNewUser = false;
            self.errorText = false;
            self.selectAllTenants('cancel')
            self.userEmail = '';
            self.newuser = {};
        },
        filterTenants(){
            var self = this;
            let params = {
                'tenant_filters': JSON.stringify(self.allTenants ? ['all_tenants'] : self.newuser.servers_list)
            }
            Vue.http.get('/get_exclude_and_include_tenants/', {
            params: params
            }).then((res)=>{
                try {
                    self.excludeTenantsList = res.data['tenant_exclude_list']
                    self.includeTenants = res.data['tenant_include_list']
                    const setExcludeTenants = new Set()
                    for(let ele in self.excludeTenantsList){
                        setExcludeTenants.add(self.excludeTenantsList[ele]['id'])
                    }
                    self.newuser.exclude_tenants = self.newuser.exclude_tenants.filter((val) => { return setExcludeTenants.has(val) })
                    const setIncludeTenants = new Set()
                    for(let ele in self.includeTenants){
                        setIncludeTenants.add(self.includeTenants[ele]['id'])
                    }
                    self.newuser.include_tenants = self.newuser.include_tenants.filter((val) => { return setIncludeTenants.has(val) })
                } catch (err){
                    console.log(err);
                }
            },(error)=>{
                console.log("Error", error);
            });
        },
        selectAllTenants(action){
            var self = this;
            if(self.newuser.servers_list.includes("all_tenants")){
                for(let ele in self.tenantGroupList){
                    if(self.tenantGroupList[ele]['field'] == 'all_tenants'){
                        continue
                    }
                    else{
                        self.tenantGroupList[ele].disabled = true
                    }
                }
                self.allTenants = true
            } 
            else {
                if(self.allTenants == true){
                    for(let ele in self.tenantGroupList){
                        self.tenantGroupList[ele].disabled = false
                    }
                }
                self.allTenants = false
            }
            if(action != 'cancel'){
                self.filterTenants()
            }
        },
        getCSFRToken(name){
            var cookieValue = null;
            if (document.cookie && document.cookie != '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = cookies[i].trim();
                    // Does this cookie string begin with the name we want?
                    if (cookie.substring(0, name.length + 1) == (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },
        resendEmail(user, text){
            var self = this, formData = new FormData();
            var csrfTOken = this.getCSFRToken('csrftoken');
            formData.append('csrfmiddlewaretoken', csrfTOken);
            formData.append('email', user.username);
            formData.append('tenantid', self.tenantInfo['domain_name']);
            formData.append('check_captcha', false);
            if(self.tenantInfo['domain_name'].length > 0){
                showLoadIcon();
                this.$loading(true);
                Vue.http.post("/password_reset/", formData)
                .then((data) => {
                    try{
                        if(data.status == 200){ 
                            self.snackbarMessage = "Successfully sent welcome email"
                            self.displaySnackbar('success-banner',self.snackbarMessage);
                            if (text == 'uigCredentials') { 
                                self.getUsers();
                            }
                        }
                        else{
                            self.snackbarMessage = "can't send welcome email"
                            self.displaySnackbar('error-banner',self.snackbarMessage);
                        }
                    }
                    catch(err){
                        console.log("error is:",err);
                    }
                    finally{
                        self.hide = hideLoadIcon();
                        if(!self.hide){
                            this.$loading(false);
                        }
                    }
                }, (error) => {
                    self.hide = hideLoadIcon();
                    if(!self.hide){
                        this.$loading(false);
                    }
                    self.displaySnackbar('error-banner',error.data.message);
                });
            }
        },
        editUser(user, index){
            var self = this, selectedApps = [],selectedDocs = [],selectedAppsTokens =[];
            self.enableNewUser = true;
            self.changeDocsAccess();
            let userAppsInfo = user['apps_information'];
            for(var i in userAppsInfo){
                if(userAppsInfo.hasOwnProperty(i)){
                    for(var j in self.collectionOfApptokensAndPk){
                        if(userAppsInfo[i].id == Object.keys(self.collectionOfApptokensAndPk[j])){
                            selectedAppsTokens.push((Object.values(self.collectionOfApptokensAndPk[j]).toString()));
                        }
                    }
                }
            }
            if(userAppsInfo){
                var i = 0;
                for(let a in userAppsInfo){
                    if(userAppsInfo.hasOwnProperty(a)){
                        selectedApps.push(userAppsInfo[a].name+selectedAppsTokens[i])
                        i++;
                    }
                }
            }
            let userDocsInfo = user['docs_information'];
            let userDocsInfo_values = Object.values(userDocsInfo)
            if(userDocsInfo){
                for(let a in userDocsInfo_values){
                    if(userDocsInfo_values.hasOwnProperty(a)){
                    selectedDocs.push(userDocsInfo_values[a]);
                    }
                }
            }
            let selected_app_type_roles_ = typeof(user.selected_app_type_roles) == 'string' ? JSON.parse(user.selected_app_type_roles) : user.selected_app_type_roles ;
            let tenant_filters= typeof(user.tenant_filters) == 'string' ? JSON.parse(user.tenant_filters) : user.tenant_filters ;
            let tenant_exclude_list = typeof(user.tenant_exclude_list) == 'string' ? JSON.parse(user.tenant_exclude_list) : user.tenant_exclude_list ;
            let tenant_include_list = typeof(user.tenant_include_list) == 'string' ? JSON.parse(user.tenant_include_list) : user.tenant_include_list ;
            let excluded_tenants = [];
            let included_tenants = [];
            for(let ele in tenant_exclude_list){
                let excludeItem = parseInt(tenant_exclude_list[ele])
                excluded_tenants.push(excludeItem)
            }
            for(let ele in tenant_include_list){
                let includeItem = parseInt(tenant_include_list[ele])
                included_tenants.push(includeItem)
            }
            console.log(user);
            self.newuser = {
                'email' : user.email,
                'password' : null,
                'cpassword' : null,
                'schema_name' : self.tenantInfo.schema_name,
                'is_staff': user.is_staff,
                'is_superuser' : user.is_superuser,
                'username' : user.username,
                'firstname' : user.first_name,
                'lastname' : user.last_name,
                'selectedApps': selectedApps,
                'servers_list': tenant_filters || [],
                'exclude_tenants': excluded_tenants || [],    
                'include_tenants': included_tenants || [],
                'selectedDocs' : selectedDocs,
                'pk': user.pk,
                'selectedUserRole': user.is_superUser_role ? 'User' : 'superAdmin',  //modify if we are getting value directly from backend
                'selected_app_type_roles': selected_app_type_roles_ || []
            };
            self.updatedUiSelectedAppsList = selectedApps;
            self.updatedUiSelectedDocsList = selectedDocs;
           
            self.selectAllTenants();
            // self.filterTenants();
        
        },
        onChange(value) {
            if(value == 'tenantGrouping' && this.newuser.servers_list != null)
            {
                var selected = this.tenantGroupList.filter(servers => this.newuser.servers_list.includes(servers['field']))
                var notSelected = this.tenantGroupList.filter(servers => !this.newuser.servers_list.includes(servers['field']))
                this.tenantGroupList = [...selected, ...notSelected];
            }
            else if(value == "includeTenant" && this.newuser.include_tenants != null)
            {
                var selected = this.includeTenants.filter(includeTenant => this.newuser.include_tenants.includes(includeTenant['id']))
                var notSelected = this.includeTenants.filter(includeTenant => !this.newuser.include_tenants.includes(includeTenant['id']))
                this.includeTenants = [...selected, ...notSelected];
            }
            else if(value == 'excludeTenant' && this.newuser.exclude_tenants != null)
            {
                var selected = this.excludeTenantsList.filter(excludeTenant => this.newuser.exclude_tenants.includes(excludeTenant['id']))
                var notSelected = this.excludeTenantsList.filter(excludeTenant => !this.newuser.exclude_tenants.includes(excludeTenant['id']))
                this.excludeTenantsList = [...selected, ...notSelected];
            }
            
        },
        convertSsoToHybrid(user) {
            this.makeUserHybrid = !this.makeUserHybrid;
            console.log(user);
        },
        filterBy,
        reverse,
        findBy,
        formateDate,
        showLoadIcon,
        hideLoadIcon
    }
}
</script>
<style scoped lang="scss">
.v-toolbar{

    .v-btn:not(.v-btn--depressed):not(.v-btn--flat) {
        will-change: box-shadow;
        box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);
    }
}
.apps_and_users_buttons{
    .v-btn{
        max-width:8.5rem;
        max-height:2.5rem;
    }
}


</style>

